module.exports = __webpack_public_path__ + "static/img/5.3dc2518.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/7/zh/5.png
// module id = 24me
// module chunks = 0